import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const DraggableList = ({ items, onListChange }) => {
  const [currentItems, setCurrentItems] = useState(items);

  const onDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    const updatedItems = Array.from(currentItems);
    const [movedItem] = updatedItems.splice(source.index, 1);
    updatedItems.splice(destination.index, 0, movedItem);

    setCurrentItems(updatedItems);
  };

  useEffect(() => {
    onListChange(currentItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItems])

  useEffect(() => {
    onListChange(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setCurrentItems(items);
    onListChange(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {(provided) => (
          <ul
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="drag-ul"
          >
            {currentItems.map((item, index) => (
              <Draggable key={item} draggableId={item} index={index}>
                {(provided) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="drag-li"
                  >
                    {index + 1}: &nbsp; {item}
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableList;
